"use client";
import FeaturedPosts from "@components/Blog/FeaturedPosts/featuredPosts";

type props = {
  lng: string;
  title: string;
  description: string;
};

export default function NotFoundComponent({ lng, title, description }: props) {
  return (
    <main className="min-h-[60vh] max-w-7xl mx-auto mt-24 md:px-16 px-6">
      <header className="max-w-4xl">
        <h1 className="font-incognito font-black tracking-tight sm:text-6xl text-3xl lg:leading-[3.7rem] leading-tight mt-6 mb-3">
          {title}
        </h1>
        <p className="max-w-2xl text-base dark:text-zinc-400 text-zinc-600 leading-relaxed">
          {description}
        </p>
      </header>

      <div className="max-w-4xl grid lg:grid-cols-2 grid-cols-1 gap-4 mt-12">
        <FeaturedPosts lng={lng} />
      </div>
    </main>
  );
}
